import { createStore } from 'vuex'
import baseconfig from '@/utils/beasconfig'
export default createStore({
  state: {
    appId: baseconfig.appId,
    appSecret: baseconfig.appSecret,
    loginInfo: sessionStorage.getItem("loginInfo") ? JSON.parse(sessionStorage.getItem("loginInfo")) : '',
    ptInfo: localStorage.getItem("ptInfo") ? JSON.parse(localStorage.getItem("ptInfo")) : '',
    agentinfo: sessionStorage.getItem("agentInfo") ? JSON.parse(sessionStorage.getItem("agentInfo")) : '',
    orginfo: sessionStorage.getItem("orgInfo") ? JSON.parse(sessionStorage.getItem("orgInfo")) : '',
    okColor: '#576b95',   //确认颜色
    languageType: [  //语言类型
      {
        name: '中文',
        language: 'zh'
      },
      {
        name: 'English',
        language: 'en'
      }
    ],
    language: localStorage.getItem('language') || 'en', //中英文
    langMsg: localStorage.getItem('language') == 'zh' ? 'cn' : 'en',  //提示的字段
    t: window.$t,     //中英文
    roleId: localStorage.getItem('roleId') ? Number(localStorage.getItem('roleId')) : 0,   //0代理商 1单位
    agent_name: '全球对讲',
    orgFenceUrl: sessionStorage.getItem("orgFenceUrl") ? sessionStorage.getItem("orgFenceUrl") : '',
    fenceUrlDk: sessionStorage.getItem("orgFenceUrl") ? `http://${sessionStorage.getItem("orgFenceUrl")}/electronicFence/list` : '',
    isXin: false,
    platform: 'xin_poc',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
